import { useState } from "react";
import  "./Roast.css";


const Roast = ({data,handleChange, count})=>{
  
  const [val, setVal] = useState(data.roast===0?0:data.roast);
  function onChangeValue(event) {
    setVal(event.target.value);
    handleChange(event);
  }
    return (

  <div class="roastCard" name="roast" onChange={onChangeValue}>
    <div class="roast-rating-container">

      <div class="roast-rating">
        <form class="roast-rating-form-1" >

          <label for={`R1F-${count}`}>
            <input type="radio"  name="roast" class="roast1" id={`R1F-${count}`}  value={1}  checked={'' + val === "1"} />
                <div className="roastcircle1"></div>
                <p className="roast-p">1</p>
           </label>

          <label for={`R2F-${count}`}>
              <input type="radio" name="roast" class="roast2" id={`R2F-${count}`} value={2} checked={'' + val === "2"} />
                <div className="roastcircle2"></div>
               <p className="invisible">.5</p>
           </label>

          <label for={`R3F-${count}`}>
              <input type="radio" name="roast" class="roast3" id={`R3F-${count}`} value={3} checked={'' + val === "3"} />
                <div className="roastcircle3"></div>
                <p className="invisible">.5</p>
            </label>

          <label for={`R4F-${count}`}>
             <input type="radio" name="roast" class="roast4" id={`R4F-${count}`} value={4} checked={'' + val === "4"} />
               <div className="roastcircle4"></div>
               <p className="invisible">.5</p>

            </label>

             <label for={`R5F-${count}`}>
             <input type="radio" name="roast" class="roast5" id={`R5F-${count}`} value={5} checked={'' + val === "5"} />
                <div className="roastcircle5"></div>
                <p>5</p>
             </label>




        </form>
      </div>
    </div>
  </div>


    );
}

export default Roast;